import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function ClosedRoleFY({ chart_data }) {
  const [data, setData] = useState({});
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (!chart_data) return;

    let months = [];
    let monthlyClosed = [];

    chart_data.forEach((item) => {
        months.push(item.month_name);
        monthlyClosed.push(
        Number(item.closer_count) === 0 ? null : item.closer_count
        );
    });

    setData({
        labels: months,
        datasets: [
        {
            label: "Closures",
            data: monthlyClosed,
            backgroundColor: "#F06E14",
            borderRadius: 5,
            barThickness: 30,
        },
        ],
    });

    setOptions({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
        legend: {
            display: false,
        },
        },
        scales: {
        y: {
            beginAtZero: true,
            ticks: {
                precision: 0,    
                stepSize: 1,     
                callback: function(value) {
                return Number.isInteger(value) ? value : null;
                }
            }
          },
        },
    });
    }, [chart_data]);

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "270px",
        }}
      >
        {data?.datasets && <Bar data={data} options={options} />}
      </div>
    </div>
  );
}

export default ClosedRoleFY;